import axios from "../axios"

// 查询团队列表
export const myTeams = (data) => {
    return axios({
		url: '/api/team/my_teams',
		method: 'get',
		params: data
    })
};


// 查找团队及成员信息
export const getTeamInfo = (data) => {
	return axios({
	url: '/api/team',
	method: 'get',
	params: data
	})
};

//修改团队成员信息
export const updateMember = (data) => {
	return axios({
	url: '/api/team/update/member',
	method: 'post',
	data: data
	})
};

//设置团队提醒时间
export const updateteam = (data) => {
	return axios({
	url: '/api/team/update/team',
	method: 'post',
	data: data
	})
};


// WEBPACK FOOTER //
// ./src/http/moudules/team.js